import { OFFER_STATUS } from 'types';

export const buyersResponseMap: Record<string, (args: boolean) => string> = {
  [OFFER_STATUS.DECLINED]: (mostRecentIsBuyer: boolean) =>
    `${mostRecentIsBuyer ? 'The seller has declined your offer.' : 'You have declined this offer.'}`,
  [OFFER_STATUS.EXPIRED]: () => 'Your offer has expired.',
  [OFFER_STATUS.AWAITING_SELLER_RESPONSE]: () => "Waiting for the seller's response...",
  [OFFER_STATUS.AWAITING_BUYER_RESPONSE]: () => 'Waiting for your response...',
  [OFFER_STATUS.CANCELLED]: () => 'Your offer has been cancelled.'
};

export const sellerResponseMap: Record<string, (args: boolean) => string> = {
  [OFFER_STATUS.DECLINED]: (mostRecentIsBuyer: boolean) =>
    `${mostRecentIsBuyer ? 'The seller has declined your offer.' : 'You have declined this offer.'}`,
  [OFFER_STATUS.EXPIRED]: () => 'Offer has expired.',
  [OFFER_STATUS.AWAITING_SELLER_RESPONSE]: () => 'Waiting for your response...',
  [OFFER_STATUS.AWAITING_BUYER_RESPONSE]: () => "Waiting for the buyer's response...",
  [OFFER_STATUS.CANCELLED]: () => 'Offer has been cancelled.'
};

export const statusWithTextUpdate = [
  OFFER_STATUS.DECLINED,
  OFFER_STATUS.EXPIRED,
  OFFER_STATUS.AWAITING_SELLER_RESPONSE,
  OFFER_STATUS.AWAITING_BUYER_RESPONSE,
  OFFER_STATUS.CANCELLED
];
